<template>
    <div>
<!--        <v-btn-->
<!--            text-->
<!--            color="white"-->
<!--            v-if="clients"-->
<!--            block-->
<!--            tile-->
<!--            class="green"-->
<!--            @click.stop="switchModal = !switchModal"-->
<!--        >-->
<!--            <v-icon class="mr-1" :size="size">mdi-arrow-right-bold-hexagon-outline</v-icon> -->
<!--            Change Arena-->
<!--        </v-btn>-->
        <v-dialog v-model="switchModal" max-width="360" >
            <v-card color="rgb(16 16 16)" class="p-relative">
                <v-card-title class="body-2 text-uppercase py-2 px-3 black--text" style="background-color:rgb(248, 158, 2)">
                    Change Arena
                    <v-spacer></v-spacer>
                    <v-btn class="black--text" icon small @click="switchModal = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-list color="rgb(16 16 16)">
                    <v-list-item
                        two-line
                        block
                        v-for="(client, index) in clients"
                        @click.stop="switchClient(client.slug)"
                        :disabled="client.status === 'closed'"
                        :key="index"
                    >
                        <v-list-item-avatar>
                            <v-icon class="red darken-4"> mdi-trophy </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ client.settings.derby_title }}</v-list-item-title>
                            <v-list-item-subtitle 
                                class="text-capitalize"
                                :class="{ 'green--text' : client.status === 'open' }"
                            >
                                {{ client.status }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
  props: {
      size: {
          default: 18,
          type: Number
      },
      clients: {
          default: null
      },
      client: {
          default: null
      }
  },
  data: () => ({
    switchModal: false,
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    openArena() {
        return this.clients.find(arena => {
            return arena.status === 'open'
        })
    }
  },
  methods: {
    switchClient(slug) {
        this.$store.dispatch('overlay', {
            message: '<strong>Switching Arena</strong><br>Please wait...',
            icon: 'loading',
            iconColor: 'orange',
            button: false
        })
       this.switchModal = false
       localStorage.setItem('slug', slug)
       window.SETTINGS.API_SLUG = slug
       this.$nextTick(() => {
           window.location.reload()
       })
    },
    autoSwitchClient() {
        if (this.client && 
            this.client.status === 'closed' && 
            this.openArena && 
            this.openArena.status === 'open') {
                this.switchClient(this.openArena.slug)
        }
    }
  },
  watch: {
      'client.status' () {
          this.$nextTick(() => {
            this.autoSwitchClient()
          })
      },
      clients () {
          this.autoSwitchClient()
      }
  },
  mounted() {
    this.autoSwitchClient()
  }
};
</script>

<style lang="sass">
.switcher
    font-size: .9em !important
.switcher-modal
    background-color: #181f35
</style>